import type { TMenuDomain, TGetterName } from '~/types/store/menus';

interface IMENU_TECH_NAMES extends Record<TGetterName, TMenuDomain> {
  [key: string]: TMenuDomain;
}

export const MENUS_TECH_NAMES: IMENU_TECH_NAMES = {
  mainArrowMenu: 'bh-kiss-first-level',
  secondArrowMenu: 'bh-kiss-second-level',
  burgerInfo: 'bh-kiss-info',
  burgerRubrics: 'bh-kiss-topics',
  burgerSocials: 'bh-kiss-socials',
  footerInfo: 'bh-kiss-footer-info',
  footerSubs: 'bh-kiss-footer-subs',
  footerRules: 'bh-kiss-footer-rules',
};
